"use strict";

exports.__esModule = true;
exports.ModalFooter = exports.ModalMessage = exports.CloseButton = exports.ModalTitle = exports.ModalHeader = exports.ModalBackground = exports.ModalContainerMedium = exports.ModalContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _templateObject8() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: 1rem;\n    display: flex;\n    justify-content: space-evenly;\n    border-top: solid thin #CCC;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteralLoose(["\n    padding: 1rem 2rem 2rem;\n    overflow-y: auto;\n    overflow-x: hidden;\n    ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteralLoose(["\n    display: flex;\n    justify-content: space-between;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n    margin: 0;\n    padding: 2rem 2rem 1rem;\n    font-size: 2rem;\n    font-weight: 600;\n    ", "\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n    float: right;\n    font-size: 28px;\n    padding: .5rem;\n    color: #777;\n\n    :hover, :focus {\n        text-decoration: none;\n        cursor: pointer;\n    }\n\n    padding: .5rem 1rem 1rem 1rem;\n    @media (max-width: 767px) {\n        font-size: 2rem; \n    }\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: #FEFEFE;\n    margin: auto;\n    width: ", ";\n    height: ", ";\n    display: flex;\n    flex-direction: column;\n    border-radius: .2rem;\n    ", "\n\n    @media only screen and (min-width: 700px) {\n        width: ", ";\n        height: ", ";\n    }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n    background-color: #FEFEFE;\n    margin: auto;\n    border: 1px solid #888;\n    width: ", ";\n    display: flex;\n    flex-direction: column;\n    border-radius: .2rem;\n    ", "\n\n    @media only screen and (min-width: 700px) {\n        width: ", ";\n    }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n    display: visible; /* Hidden by default */\n    position: fixed; /* Stay in place */\n    z-index: 100; /* Sit on top */\n    padding: ", "; \n    left: 0;\n    top: 0;\n    width: 100%; /* Full width */\n    height: 100%; /* Full height */\n    overflow: auto; /* Enable scroll if needed */\n    background-color: rgb(0,0,0); /* Fallback color */\n    background-color: ", "; \n    @media only screen and (min-width: 700px) {\n        padding: ", "; \n    }\n    ", "\n    \n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  strings.raw = raw;
  return strings;
}

var ModalBackground = _styledComponents["default"].div(_templateObject(), function (props) {
  return props.isFullScreenOnMobile || props.isFullScreen ? "0rem" : props.padding ? props.padding : "5rem 0rem";
}, function (props) {
  return props.backgroundColor ? props.backgroundColor : 'rgba(0,0,0,0.4)';
}, function (props) {
  return props.isFullScreen ? "0rem" : "5rem 0rem";
}, function (props) {
  return props.centerContent ? "display: flex; justify-content: center; align-items: center;" : "";
});

exports.ModalBackground = ModalBackground;

var ModalContainer = _styledComponents["default"].div(_templateObject2(), function (props) {
  return props.isFullScreenOnMobile || props.isFullScreen ? "100%" : "80%";
}, function (props) {
  return props.style;
}, function (props) {
  return props.isFullScreen ? "100%" : "40%";
});

exports.ModalContainer = ModalContainer;

var ModalContainerMedium = _styledComponents["default"].div(_templateObject3(), function (props) {
  return props.isFullScreenOnMobile || props.isFullScreen ? "100%" : "95%";
}, function (props) {
  return props.isFullScreenOnMobile || props.isFullScreen ? " 100%" : "auto";
}, function (props) {
  return props.style;
}, function (props) {
  return props.isFullScreen ? "100%" : "60%";
}, function (props) {
  return props.isFullScreen ? " 100%" : "auto";
});

exports.ModalContainerMedium = ModalContainerMedium;

var CloseButton = _styledComponents["default"].div(_templateObject4());

exports.CloseButton = CloseButton;

var ModalTitle = _styledComponents["default"].div(_templateObject5(), function (props) {
  return props.titleStyle;
});

exports.ModalTitle = ModalTitle;

var ModalHeader = _styledComponents["default"].div(_templateObject6());

exports.ModalHeader = ModalHeader;

var ModalMessage = _styledComponents["default"].div(_templateObject7(), function (props) {
  return props.messageStyle;
});

exports.ModalMessage = ModalMessage;

var ModalFooter = _styledComponents["default"].div(_templateObject8());

exports.ModalFooter = ModalFooter;